// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import DocumentMeta from 'react-document-meta'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import PageEvents from './PageEvents'
import Recaptchas from 'components/recaptchas/recaptchas'
import Content from './Content'
import Animals from './Animals'
import HappyTails from './HappyTails'
import Tributes from './Tributes'
import Stories from './Stories'
import Faqs from './Faqs'
import Sponsors from 'components/sponsors/sponsors'
import ApplyButton from './ApplyButton'
import Adoptions from './Adoptions'
import Checkbox from 'components/form/checkbox'

// Redux:
import { setSidebarVisibility } from 'actions/site'
import { getPageData } from 'actions/page'
import { currentPage } from 'selectors/page'
import { showAdopted, getAnimalsData, setAnimalsType, getHappyTailsData, getTributesData, getStoriesData, setSelectedAnimal } from 'actions/animals'
import { selectedAnimal } from 'selectors/animals'

const host = window.location.host

class Page extends React.Component {
	constructor() {
		super()

		this.state = {

		}
	}

	componentDidMount() {
		if ( ! this.props.match ) {
			return
		}

		const { history, page } = this.props
		const locationHash = history.location.hash.slice( 1 )
		const isAnimal = history.location.pathname.indexOf( '/animal/' ) > -1

		// Scroll to the top when not jumping to an anchor:
		if ( ! locationHash && ! isAnimal ) {
			window.scrollTo( 0, 0 )
		}

		const { params, path } = this.props.match

		if ( '/' == path ) {
			this.props.getPost( 'home', 'page' )
		} else if ( params.page ) {
			if ( params.archivePageNumber ) {
				this.props.getPost( params.page, 'page', params.archivePageNumber )
			} else {
				this.props.getPost( params.page, 'page' )
			}
		} else if ( params.blog ) {
			this.props.getPost( params.blog, 'post' )
		} else if ( params.blogCategory ) {
			this.props.getPost( params.blogCategory, 'post-category' )
		}

		this.props.getPost( 'responsible-containment', 'page', false, true )
		this.props.getPost( 'ehrlichiosis', 'page', false, true )
		this.props.getAnimals()
		this.props.getHappyTails()
		this.props.getTributes()
		this.props.getStories()

		if ( page && 'adopted' != page.template ) {
			this.props.setShowAdopted( false )
		}
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( ! this.props.match ) {
			return
		}

		const { page, animalsType, showAdopted } = this.props
		const { params, path } = this.props.match
		const prevParams = prevProps.match.params
		const prevPath = prevProps.match.path

		const { history } = this.props
		const locationHash = history.location.hash.slice( 1 )

		// Scroll to the top when not jumping to an anchor:
		if ( ! locationHash && params.page && prevParams.page !== params.page ) {
			window.scrollTo( 0, 0 )
		}

		if ( '/' == path && '/' !== prevPath ) {
			this.props.getPost( 'home', 'page' )
		} else if ( params.page && prevParams.page !== params.page ) {
			this.props.getPost( params.page, 'page' )
		} else if ( params.page && params.archivePageNumber && prevParams.archivePageNumber !== params.archivePageNumber ) {
			this.props.getPost( params.page, 'page', params.archivePageNumber )
		} else if ( params.blog && prevParams.blog !== params.blog ) {
			this.props.getPost( params.blog, 'post' )
		} else if ( params.blogCategory && prevParams.blogCategory !== params.blogCategory ) {
			this.props.getPost( params.blogCategory, 'post-category' )
		}

		if ( page ) {
			if ( 'adopt-dogs' == page.template
				|| 'adopt-cats' == page.template
				|| 'adopt-other' == page.template
				|| 'adopted' == page.template
				|| 'apply' == page.template ) {
				this.props.setSidebarVisibility( false )
			} else {
				this.props.setSidebarVisibility( true )
			}

			if ( 'adopt-dogs' == page.template && 'dog' != animalsType ) {
				this.props.setAnimalsType( 'dog' )
			} else if ( 'adopt-cats' == page.template && 'cat' != animalsType ) {
				this.props.setAnimalsType( 'cat' )
			} else if ( 'adopt-other' == page.template && 'other' != animalsType ) {
				this.props.setAnimalsType( 'other' )
			} else if ( 'adopted' == page.template && 'any' != animalsType ) {
				this.props.setAnimalsType( 'any' )
			}
		}

		if ( params.animal ) {
			this.props.setSelectedAnimal( params.animal )
		} else {
			this.props.setSelectedAnimal( false )
		}

		if ( 'adopted' != page.template && showAdopted ) {
			this.props.setShowAdopted( false )
		}
	}

	renderLoading() {
		return (
			<div className="primary-content-inner primary-content-is-loading">

			</div>
		)
	}

	renderContent() {
		const { match, page, animalsType } = this.props

		if ( ! page ) {
			return null
		}

		let pagePath = '/' + match.params.page

		if ( match.params.subpage ) {
			pagePath += '/' + match.params.subpage
		}

		const meta = {
			title: page.title.raw,
			description: page.description,
			canonical: safeSiteData.site_url + pagePath,
			meta: {
				'og:url': safeSiteData.site_url + pagePath,
				'og:title': page.title.raw,
				'og:description': page.description,
				'og:image': page.featured_image.url
			}
		}

		const { params } = match
		let showAnimals = false,
			showAdoptions = false,
			showHappyTails = false,
			showTributes = false,
			showStories = false,
			showFaqs = false,
			showSponsors = false

		if ( 'adopt-dogs' == page.template || 'adopt-cats' == page.template || 'adopt-other' == page.template || 'adopted' == page.template ) {
			showAnimals = true
		} else if ( 'happy-tails' == page.template ) {
			showHappyTails = true
		} else if ( 'tributes' == page.template ) {
			showTributes = true
		} else if ( 'stories' == page.template ) {
			showStories = true
		} else if ( 'faqs' == page.template ) {
			showFaqs = true
		} else if ( 'sponsors' == page.template ) {
			showSponsors = true
		}

		if ( 'adopted' == page.template ) {
			showAdoptions = true
		}

		const pageContent = (
			<div>
				<PageEvents />

				{ ! showAnimals &&
					<Content />
				}

				{ showAdoptions &&
					<Adoptions { ...this.props } />
				}

				{ showAnimals &&
					<Animals subpage={ params.subpage } { ...this.props } />
				}

				{ showHappyTails &&
					<HappyTails />
				|| showTributes &&
					<Tributes />
				|| showStories &&
					<Stories />
				|| showFaqs &&
					<Faqs />
				|| showSponsors &&
					<Sponsors sponsorsPage={ true } />
				}

				{ 'apply' == page.template &&
					<ApplyButton />
				}
			</div>
		)

		return (
			<div className="primary-content-inner primary-content-is-ready">
				<DocumentMeta { ...meta } />

				{ pageContent }

				<Recaptchas match={ this.props.match } />
			</div>
		)
	}

	render() {
		return (
			<div>
				{ this.props.page.isLoading ? this.renderLoading() : this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let animalsById

	switch ( state.animals.animalsType ) {
		case 'cat':
			animalsById = state.animals.catsById
			break

		case 'other':
			animalsById = state.animals.otherById
			break

		default:
			animalsById = state.animals.dogsById
	}

	return {
		page: currentPage( state ),
		allPages: state.page.byId,
		animalsType: state.animals.animalsType,
		animalsById: animalsById,
		showAdopted: state.animals.showAdopted
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getPost: ( slug, type, archivePageNumber, requestOnly = false ) => {
			dispatch( getPageData( slug, type, archivePageNumber, requestOnly ) )
		},

		setShowAdopted: ( bool ) => {
			dispatch( showAdopted( bool ) )
		},

		getAnimals: () => {
			dispatch( getAnimalsData( 'dog' ) )
			dispatch( getAnimalsData( 'cat' ) )
			dispatch( getAnimalsData( 'other' ) )
		},

		setAnimalsType: ( type ) => {
			dispatch( setAnimalsType( type ) )
		},

		getHappyTails: () => {
			dispatch( getHappyTailsData() )
		},

		getTributes: () => {
			dispatch( getTributesData() )
		},

		getStories: () => {
			dispatch( getStoriesData() )
		},

		setSelectedAnimal: ( id ) => {
			dispatch( setSelectedAnimal( id ) )
		},

		setSidebarVisibility: ( val ) => {
			dispatch( setSidebarVisibility( val ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Page )



// WEBPACK FOOTER //
// ./views/main/page/Page.jsx